export const animationName = (event) => event.animationName
export const elapsedTime = (event) => event.elapsedTime
export const pseudoElement = (event) => event.pseudoElement
export const clipboardData = (event) => event.clipboardData
export const detail = (event) => event.detail
export const view = (event) => event.view
export const dataTransfer = (event) => event.dataTransfer
export const relatedTarget = (event) => event.relatedTarget
export const data = (event) => event.nativeEvent.data ?? ""
export const value = (event) => event.target.value
export const altKey = (event) => event.altKey
export const code = (event) => event.code
export const button = (event) => event.button
export const buttons = (event) => event.buttons
export const ctrlKey = (event) => event.ctrlKey
export const clientX = (event) => event.clientX
export const clientY = (event) => event.clientY
export const offsetX = (event) => event.offsetX
export const offsetY = (event) => event.offsetY
export const metaKey = (event) => event.metaKey
export const key = (event) => event.key
export const locale = (event) => event.locale
export const location = (event) => event.location
export const repeat = (event) => event.repeat
export const movementX = (event) => event.movementX
export const movementY = (event) => event.movementY
export const pageX = (event) => event.pageX
export const pageY = (event) => event.pageY
export const screenX = (event) => event.screenX
export const screenY = (event) => event.screenY
export const shiftKey = (event) => event.shiftKey
export const height = (event) => event.height
export const width = (event) => event.width
export const isPrimary = (event) => event.isPrimary
export const altitudeAngle = (event) => event.altitudeAngle
export const azimuthAngle = (event) => event.azimuthAngle
export const pointerId = (event) => event.pointerId
export const pointerType = (event) => event.pointerType
export const pressure = (event) => event.pressure
export const tangentialPressure = (event) => event.tangentialPressure
export const tiltX = (event) => event.tiltX
export const tiltY = (event) => event.tiltY
export const twist = (event) => event.twist
export const changedTouches = (event) => event.changedTouches
export const touches = (event) => event.touches
export const targetTouches = (event) => event.targetTouches
export const propertyName = (event) => event.propertyName
export const deltaMode = (event) => event.deltaMode
export const deltaX = (event) => event.deltaX
export const deltaY = (event) => event.deltaY
export const deltaZ = (event) => event.deltaZ
export const getModifierState = (event, key) => event.getModifierState(key)
